import { required, requiredIf } from 'vuelidate/lib/validators'

const defaultEl = {
  id: null,
  comment_type: null,
  user_id: null,
  comment: ''
};

export default {
  name: 'ClientComment',
  data () {
    return {
      editEl: defaultEl,
      loading: false,
      clientUuid: null,
      isBlockedComment: false,
      isBlocked: 0
    }
  },
  validations: {
    editEl: {
      comment_type: { required },
      comment: {
        required: requiredIf(function () {
          return this.isSimpleComment
        })
      }
    }
  },
  computed: {
    getTitle () {
      if (this.isBlockedComment) {
        if (this.isBlocked) {
          return this.$t('menu.clients.block');
        }
        return this.$t('menu.clients.unblock');
      } else if (this.editEl.id) {
        return this.$t('menu.comment.edit');
      }
      return this.$t('menu.comment.new');
    },
    isSimpleComment () {
      return !this.isBlockedComment;
    },
    commentTypeOptions () {
      return this.$store.getters.getConfigOptions('comment_types', this.$i18n.locale);
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-clients');
    }
  },
  methods: {
    show (elData, clientUuid, isBlockedComment = false, isBlocked = false) {
      this.isBlockedComment = isBlockedComment;
      this.isBlocked = isBlocked;
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      this.editEl.comment_type = this.$store.getters.getParamFromConfig('comment_types', this.editEl.comment_type_id, 'code')
      this.clientUuid = clientUuid;
      this.$v.$reset();
      this.$refs['modal-window'].show();
    },
    save () {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        const self = this;
        const reqData = { id: this.editEl.id, comment_type: this.editEl.comment_type, comment: this.editEl.comment };
        const path = 'client/single/' + this.clientUuid + '/comments';
        if (this.isBlockedComment) {
          reqData.isBlocked = this.isBlocked;
        }
        this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, { comment: reqData }, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$emit('saved', response.data);
            self.close();
          }
          self.loading = false;
        });
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    }
  }
}
